module.exports = ".breadcrumb-color .breadcrumb-item a:hover {\r\n    color: #969696; }\r\n\r\n.breadcrumb .active span {\r\n    color: #969696; }"